import { render } from "./List.vue?vue&type=template&id=72234fc6&bindings={\"programs\":\"options\",\"showPrograms\":\"options\",\"selection\":\"options\",\"questionsConfig\":\"options\",\"allOptions\":\"options\",\"pdf\":\"options\",\"selectionTags\":\"options\",\"downloadUrl\":\"options\",\"downloadPDF\":\"options\"}"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
script.render = render

export default script